var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Modal",
    {
      attrs: { visible: _vm.visible, "max-width": "600px", persistent: true },
      on: {
        "close-modal": function ($event) {
          return _vm.$emit("close-modal")
        },
        "update-user-table": function ($event) {
          return _vm.$emit("update-user-table")
        },
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "elevation-12" },
        [
          _c(
            "v-toolbar",
            { attrs: { color: "primary", dark: "", flat: "" } },
            [
              _c(
                "v-toolbar-title",
                { attrs: { id: "registration_form_title" } },
                [_vm._v(" Register to Heimdall Server ")]
              ),
              _c("v-spacer"),
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { name: "signup_form" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.register.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        [
                          _c("v-text-field", {
                            attrs: {
                              id: "firstName_field",
                              "error-messages": _vm.requiredFieldError(
                                _vm.$v.firstName,
                                "First Name"
                              ),
                              name: "firstName",
                              label: "First Name",
                              "prepend-icon": "mdi-account",
                              type: "text",
                              tabindex: "1",
                            },
                            on: {
                              blur: function ($event) {
                                return _vm.$v.firstName.$touch()
                              },
                            },
                            model: {
                              value: _vm.firstName,
                              callback: function ($$v) {
                                _vm.firstName = $$v
                              },
                              expression: "firstName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        [
                          _c("v-text-field", {
                            attrs: {
                              id: "lastName_field",
                              "error-messages": _vm.requiredFieldError(
                                _vm.$v.lastName,
                                "Last Name"
                              ),
                              name: "lastName",
                              label: "Last Name",
                              type: "text",
                              tabindex: "2",
                            },
                            on: {
                              blur: function ($event) {
                                return _vm.$v.lastName.$touch()
                              },
                            },
                            model: {
                              value: _vm.lastName,
                              callback: function ($$v) {
                                _vm.lastName = $$v
                              },
                              expression: "lastName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-text-field", {
                    attrs: {
                      id: "email_field",
                      "error-messages": _vm.emailErrors(_vm.$v.email),
                      name: "email",
                      label: "Email",
                      "prepend-icon": "mdi-at",
                      type: "text",
                      tabindex: "3",
                    },
                    on: {
                      blur: function ($event) {
                        return _vm.$v.email.$touch()
                      },
                    },
                    model: {
                      value: _vm.email,
                      callback: function ($$v) {
                        _vm.email = $$v
                      },
                      expression: "email",
                    },
                  }),
                  _c("br"),
                  _c("v-text-field", {
                    attrs: {
                      id: "password",
                      "prepend-icon": "mdi-lock",
                      name: "password",
                      label: "Password",
                      type: _vm.showPassword ? "text" : "password",
                      tabindex: "4",
                    },
                    on: {
                      blur: function ($event) {
                        return _vm.$v.password.$touch()
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "append",
                        fn: function () {
                          return [
                            _c(
                              "v-icon",
                              {
                                on: {
                                  click: function ($event) {
                                    _vm.showPassword = !_vm.showPassword
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.showPassword ? "mdi-eye" : "mdi-eye-off"
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.password,
                      callback: function ($$v) {
                        _vm.password = $$v
                      },
                      expression: "password",
                    },
                  }),
                  _vm._l(_vm.validatorList, function (validator, i) {
                    return _c(
                      "v-row",
                      {
                        key: i,
                        class: validator.check(_vm.password)
                          ? "d-flex success--text"
                          : "d-flex error--text",
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "pl-9",
                            attrs: {
                              color: validator.check(_vm.password)
                                ? "success"
                                : "error",
                              small: "",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                validator.check(_vm.password)
                                  ? "mdi-check"
                                  : "mdi-close"
                              )
                            ),
                          ]
                        ),
                        _c(
                          "small",
                          { staticClass: "pl-1", attrs: { color: "red" } },
                          [_vm._v(_vm._s(validator.name))]
                        ),
                      ],
                      1
                    )
                  }),
                  _c("br"),
                  _c("v-text-field", {
                    attrs: {
                      id: "passwordConfirmation",
                      name: "passwordConfirmation",
                      "error-messages": _vm.requiredFieldError(
                        _vm.$v.passwordConfirmation,
                        "Password Confirmation"
                      ),
                      label: "Confirm Password",
                      "prepend-icon": "mdi-lock-alert",
                      type: "password",
                    },
                    on: {
                      blur: function ($event) {
                        return _vm.$v.passwordConfirmation.$touch()
                      },
                    },
                    model: {
                      value: _vm.passwordConfirmation,
                      callback: function ($$v) {
                        _vm.passwordConfirmation = $$v
                      },
                      expression: "passwordConfirmation",
                    },
                  }),
                  _c("br"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        id: "register",
                        depressed: "",
                        large: "",
                        disabled: _vm.registrationDisabled,
                        color: "primary",
                        type: "submit",
                        loading: _vm.buttonLoading,
                      },
                    },
                    [_vm._v(" Register ")]
                  ),
                ],
                2
              ),
            ],
            1
          ),
          !_vm.adminRegisterMode
            ? _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "div",
                    { staticClass: "my-2" },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: "/login" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                id: "login_button",
                                depressed: "",
                                small: "",
                              },
                            },
                            [_vm._v("Login")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }